"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgTrendingUp = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M35 17h.02c.023 0 .046.002.07.004L35 17a1.008 1.008 0 01.617.213c.063.05.12.107.17.17l-.08-.09a1.008 1.008 0 01.292.675L36 18v6a1 1 0 01-2 0v-3.586l-7.793 7.793a1 1 0 01-1.414 0L20.5 23.914l-6.793 6.793a1 1 0 01-1.414-1.414l7.5-7.5a1 1 0 011.414 0l4.293 4.293L32.584 19H29a1 1 0 010-2h6z",
    id: "trending-up_svg__a"
  }));
};

var _default = SvgTrendingUp;
exports.default = _default;